<template>
  <div class="container">
    <h2>differ</h2>
    <div id="output"></div>
  </div>
</template>

<script>
import differ from "../classes/htmldiff";
export default {
  name: "htmldiff",
  data() {
    return {};
  },
  methods: {},
  mounted() {
    let originalHTML = `
    <h5 class="text-center">چگونه از افزایش عصبانیت کودکان در محیط خانه جلوگیری کنیم؟</h5><p class="text-right">بیماری کرونا موجب ایجاد احساساتی نظیر اضطراب، استرس و پرخاشگری می گردد. این احساسات به ویژه در میان کودکان و نوجوانان، در سنین مختلف، بیشتر دیده می شوند اما با راهکارهایی می‌توان از بروز این احساسات در کودکان جلوگیری کرد.</p><div class="uploaderwrap custom-file my-3"><img class="img-fluid" src="https://img.tebyan.net/big/1400/02/542042816231242174116901885222126595592.jpg" alt="کرونا" title="کرونا" /><p class="figcaption">کرونا</p></div><p class="text-right">تعطیلی مدارس و شرایط قرنطینه ناشی از کرونا سبب شده تغییرات زیادی در خانواده­‌ها و همچنین رفتار فرزندان در محیط خانه اتفاق بیفتد. اینکه والدین چگونه با این تغییرات روبرو شوند و چه عکس‌­العمل و واکنشی نسبت به این رفتارها داشته باشند می‌­تواند در کاهش استرس و اضطراب کودکان در این دوران کمک چشمگیری کند. راهکارهایی برای جلوگیری از افزایش دعوا و عصبانیت کودکان در محیط خانه و همچنین ترس و اضطراب و اختلالات شبانه از جمله   مواردی است که در این گزارش به آنها پرداخته شده است</p><h5 class="text-right">دعوا و عصبانیت کودکان</h5><p class="text-right">یکی از تغییرات رایج فرزندان که والدین در زمان بحران کرونا با آن مواجه می­‌شوند افزایش درگیری و پرخاشگری است. این ماجرا واکنش طبیعی کودکان به تغییراتی است که در حال تجربه آن هستند. فعالیت‌های روزمره کودکان و نوع ارتباط والدین با آنها بر رفتار کودکان تأثیر می­‌گذارد. بنابراین <mark class="cdx-marker">راهکار مناسب برای جلوگیری از دعوا و پرخاشگری کودکان در محیط خانه، داشتن قوانین مشخص و روشن در مورد کارهایی است که فرزندان مجاز یا غیرمجاز به انجام آن هستند.</mark></p>
`;

    let newHTML = `
<h5 class="text-center">چگونه از افزایش عصبانیت کودکان در محیط خانه جلوگیری کنیم؟</h5><p class="text-right">بیماری کرونا موجب ایجاد احساساتی نظیر اضطراب، استرس و پرخاشگری می گردد. این احساسات به ویژه در میان کودکان و نوجوانان، در سنین مختلف، بیشتر دیده می شوند اما با راهکارهایی می‌توان از بروز این احساسات در کودکان جلوگیری کرد.</p><p class="text-right">تعطیلی مدارس و شرایط قرنطینه ناشی از کرونا سبب نشده تغییرات زیادی در خانواده­‌ها و همچنین رفتار فرزندان در محیط اتاق اتفاق بیفتد. اینکه والدین چگونه با این تغییرات روبرو شوند و چه عکس‌­العمل و واکنشی نسبت به این رفتارها داشته باشند می‌­تواند در کاهش استرس و اضطراب کودکان در این دوران کمک چشمگیری نمیکند. </p><p class="text-right">راهکارهایی برای جلوگیری از افزایش دعوا و عصبانیت کودکان در محیط خانه و همچنین ترس و اضطراب و اختلالات شبانه از جمله   مواردی است که در این گزارش به آنها پرداخته شده است</p><p class="text-right">این خط به متن اضافه شده است</p><h5 class="text-right">دعوا و عصبانیت کودکان</h5><p class="text-right">&nbsp;افزایش درگیری و پرخاشگری است. این ماجرا واکنش طبیعی کودکان به تغییراتی است که در حال تجربه آن هستند. فعالیت‌های روزمره کودکان و نوع ارتباط والدین با آنها بر رفتار کودکان تأثیر می­‌گذارد. بنابراین <mark class="cdx-marker">راهکار مناسب برای جلوگیری از دعوا و پرخاشگری کودکان در محیط خانه، داشتن قوانین مشخص و روشن در مورد کارهایی است که فرزندان مجاز یا غیرمجاز به انجام آن هستند.</mark></p><div class="uploaderwrap custom-file my-3"><img class="img-fluid" src="https://img.tebyan.net/big/1400/02/12810012215513984162323116173176121749123.jpg" alt="اکسیژن" title="اکسیژن خون" /><p class="figcaption">اکسیژن خون</p></div>
`;

    // Diff HTML strings
    let output = differ(originalHTML, newHTML);

    // Show HTML diff output as HTML (crazy right?)!
    document.getElementById("output").innerHTML = output;
  },
};
</script>

<style>
ins {
  text-decoration: none;
  background-color: #d4fcbc;
}

del {
  text-decoration: line-through;
  background-color: #fbb6c2;
  color: #555;
}
#output{
    max-width: 600px;
    margin: 0 auto;
}
#output img{
    width: 100%;
}
</style>